<template>
    <div id="AlertData">
        <HrrBreadcrumb PMname="其他功能" CMname="媒体检测管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="站点：">
                        <el-select v-model="searchform.siteId" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="检测时间段：">
                        <el-date-picker v-model="searchform.startTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="是否异常：" prop="isAbnormal">
                        <el-select v-model="searchform.isAbnormal" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="否" value="0"></el-option>
                            <el-option label="是" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="巡检人 " value="usersName"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick">新增</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <!--<el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始时间" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width="160" fixed="left" sortable>
                    </el-table-column>-->
                    <el-table-column prop="siteName" label="站点" width="180">
                    </el-table-column>
                    <el-table-column prop="LightBoxCode" label="媒体编号" width="160">
                    </el-table-column>
                    <el-table-column prop="inspectionDate" label="巡检时间" width="160">
                    </el-table-column>
                    <el-table-column prop="usersName" label="巡检人" width="200">
                    </el-table-column>
                    <el-table-column prop="checkupContect" label="巡检内容说明" >
                    </el-table-column>
                    <el-table-column prop="isAbnormal" label="是否异常" width="100">
                        <template slot-scope="scope">
                            {{scope.row.isAbnormal?"是":"否"}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="180">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="180">
                    </el-table-column>
                    <!--<el-table-column label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">重新发送</el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'lightbox_info',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteId: "",
                isAbnormal: "",
                deviceNickCode: "",
                lightBoxCode: "",
                status: "",
                startTime: "",
                endTime: ""
            },
            siteidData: [],
            configData: [],
            tableData: [],
            total: 0,
            loading: true,
            selectionRows: [],
            selectfield: "usersName",
            keyword: ""
        }
    },
    methods: {
        onSubmit() {
            this.searchform.lightBoxCode = "";
            this.searchform.deviceNickCode = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.$route.meta.Alert = this.searchform;
            this.initData();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/lightbox/info/view/' + val.lightBoxId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.lightbox.DelLightbox + "/" + myrow.lightBoxId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        Addclick() {
            this.$router.push({ path: '/lightbox/checkup/add/', });
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.DeviceCheckUpLog.api, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$hrraxios.get(this.$api.AlertConfig.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.configData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.Alert = from.meta.Alert;
        next();
    },
    created() {
        this.$common.getFunListByMCode(this, "AlertData", () => {
            if (this.$route.meta.Alert != undefined) {
                this.searchform = this.$route.meta.Alert;
            }
            this.initData();
            this.initParamsData();
        });
    }
};
</script>